<section class="content-section">
  <div style="margin-bottom: 24px; display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 12px;">
    <a [routerLink]="'/commande/lister'" class="btn btn-secondary" style="display: inline-flex; align-items: center; gap: 8px;">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
        <line x1="19" y1="12" x2="5" y2="12"></line>
        <polyline points="12 19 5 12 12 5"></polyline>
      </svg>
      Retour à la liste
    </a>
    <div class="mode-badge" [class.view]="estModeConsultation" [class.edit]="!estModeConsultation">
      <span>{{ estModeConsultation ? '🔒 MODE LECTURE' : '✏️ MODE ÉDITION' }}</span>
    </div>
  </div>

  <!-- VIEW MODE: Creative Premium Design -->
  <ng-container *ngIf="estModeConsultation">
  <div class="cmd-page" *ngIf="commandeDetail">

    <!-- ══ HERO ══ -->
    <div class="cmd-hero">
      <div class="cmd-hero__orb cmd-hero__orb--1"></div>
      <div class="cmd-hero__orb cmd-hero__orb--2"></div>
      <div class="cmd-hero__orb cmd-hero__orb--3"></div>
      <div class="cmd-hero__content">

        <!-- Top : ref + statut -->
        <div class="cmd-hero__top">
          <div>
            <span class="cmd-hero__eyebrow">Commande</span>
            <h1 class="cmd-hero__ref">{{ commandeDetail.numeroCommande || commandeDetail.numeroSuivi || '—' }}</h1>
            <div class="cmd-hero__meta">
              <span *ngIf="obtenirDatePassage()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                {{ obtenirDatePassage() | date:'dd MMM yyyy, HH:mm' }}
              </span>
              <span *ngIf="commandeDetail.numeroSuivi" style="font-family:monospace">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 0 0 1.946-.806 3.42 3.42 0 0 1 4.438 0 3.42 3.42 0 0 0 1.946.806 3.42 3.42 0 0 1 3.138 3.138 3.42 3.42 0 0 0 .806 1.946 3.42 3.42 0 0 1 0 4.438 3.42 3.42 0 0 0-.806 1.946 3.42 3.42 0 0 1-3.138 3.138 3.42 3.42 0 0 0-1.946.806 3.42 3.42 0 0 1-4.438 0 3.42 3.42 0 0 0-1.946-.806 3.42 3.42 0 0 1-3.138-3.138 3.42 3.42 0 0 0-.806-1.946 3.42 3.42 0 0 1 0-4.438 3.42 3.42 0 0 0 .806-1.946 3.42 3.42 0 0 1 3.138-3.138z"/></svg>
                {{ commandeDetail.numeroSuivi }}
              </span>
            </div>
          </div>
          <span class="vd-statut-chip" [ngClass]="'vd-chip-' + commandeDetail.statut">{{ obtenirTexteStatut(commandeDetail.statut) }}</span>
        </div>

        <!-- KPIs glassmorphiques -->
        <div class="cmd-kpis">
          <div class="cmd-kpi cmd-kpi--green">
            <div class="cmd-kpi__icon-w">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
            </div>
            <div class="cmd-kpi__info">
              <span class="cmd-kpi__val">{{ commandeForm.value['montantTotalForfait'] + commandeForm.value['montantTotalSupplementaire'] - (commandeForm.value['montantRemise'] || 0) | number:'1.0-0' }}</span>
              <span class="cmd-kpi__lbl">FCFA</span>
            </div>
          </div>
          <div class="cmd-kpi cmd-kpi--amber">
            <div class="cmd-kpi__icon-w">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
            </div>
            <div class="cmd-kpi__info">
              <span class="cmd-kpi__val">{{ articlesCmd?.controls?.length || 0 }}</span>
              <span class="cmd-kpi__lbl">Articles</span>
            </div>
          </div>
          <div class="cmd-kpi cmd-kpi--indigo">
            <div class="cmd-kpi__icon-w">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
            </div>
            <div class="cmd-kpi__info">
              <span class="cmd-kpi__val cmd-kpi__val--sm" *ngIf="commandeForm.value.typeEnvoi">{{ obtenirLibelle(typeEnvoiOptions, commandeForm.value.typeEnvoi) }}</span>
              <span class="cmd-kpi__val cmd-kpi__val--sm" *ngIf="!commandeForm.value.typeEnvoi">—</span>
              <span class="cmd-kpi__lbl">Prestation</span>
            </div>
          </div>
          <div class="cmd-kpi cmd-kpi--teal">
            <div class="cmd-kpi__icon-w">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
            </div>
            <div class="cmd-kpi__info">
              <span class="cmd-kpi__val cmd-kpi__val--sm" *ngIf="commandeForm.value.moyenTransport">{{ obtenirLibelle(moyenTransportOptions, commandeForm.value.moyenTransport) }}</span>
              <span class="cmd-kpi__val cmd-kpi__val--sm" *ngIf="!commandeForm.value.moyenTransport">—</span>
              <span class="cmd-kpi__lbl">Transport</span>
            </div>
          </div>
        </div>

        <!-- Stepper intégré dans le héro -->
        <div class="cmd-stepper">
          <div class="cmd-step-rail">
            <div class="cmd-step-fill" [style.width.%]="obtenirProgressionStepper(commandeDetail.statut)"></div>
          </div>
          <div class="cmd-milestones">
            <div class="cmd-ms" [class.done]="['AFFECTE','EN_PREPARATION','EN_LIVRAISON','LIVRE'].includes(commandeDetail.statut)" [class.active]="commandeDetail.statut === 'EN_ATTENTE'">
              <div class="cmd-ms__dot"><svg *ngIf="['AFFECTE','EN_PREPARATION','EN_LIVRAISON','LIVRE'].includes(commandeDetail.statut)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" stroke="#fff" stroke-width="2.5" width="8" height="8"><polyline points="1.5 5 4 7.5 8.5 2"/></svg></div>
              <span class="cmd-ms__lbl">Enregistrée</span>
            </div>
            <div class="cmd-ms" [class.done]="['EN_PREPARATION','EN_LIVRAISON','LIVRE'].includes(commandeDetail.statut)" [class.active]="commandeDetail.statut === 'AFFECTE'">
              <div class="cmd-ms__dot"><svg *ngIf="['EN_PREPARATION','EN_LIVRAISON','LIVRE'].includes(commandeDetail.statut)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" stroke="#fff" stroke-width="2.5" width="8" height="8"><polyline points="1.5 5 4 7.5 8.5 2"/></svg></div>
              <span class="cmd-ms__lbl">Livreur assigné</span>
            </div>
            <div class="cmd-ms" [class.done]="['EN_LIVRAISON','LIVRE'].includes(commandeDetail.statut)" [class.active]="commandeDetail.statut === 'EN_PREPARATION'">
              <div class="cmd-ms__dot"><svg *ngIf="['EN_LIVRAISON','LIVRE'].includes(commandeDetail.statut)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" stroke="#fff" stroke-width="2.5" width="8" height="8"><polyline points="1.5 5 4 7.5 8.5 2"/></svg></div>
              <span class="cmd-ms__lbl">Vers retrait</span>
            </div>
            <div class="cmd-ms" [class.done]="commandeDetail.statut === 'LIVRE'" [class.active]="commandeDetail.statut === 'EN_LIVRAISON'">
              <div class="cmd-ms__dot"><svg *ngIf="commandeDetail.statut === 'LIVRE'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" stroke="#fff" stroke-width="2.5" width="8" height="8"><polyline points="1.5 5 4 7.5 8.5 2"/></svg></div>
              <span class="cmd-ms__lbl">En route</span>
            </div>
            <div class="cmd-ms" [class.done]="commandeDetail.statut === 'LIVRE'">
              <div class="cmd-ms__dot"><svg *ngIf="commandeDetail.statut === 'LIVRE'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" stroke="#fff" stroke-width="2.5" width="8" height="8"><polyline points="1.5 5 4 7.5 8.5 2"/></svg></div>
              <span class="cmd-ms__lbl">Livrée</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ══ BENTO ROW 1 : Main + Aside ══ -->
    <div class="cmd-bento-r1">

      <!-- Colonne principale -->
      <div class="cmd-main">

        <!-- Bloc itinéraire + parties -->
        <div class="cmd-block cmd-block--route">
          <div class="cmd-block__hdr">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><polygon points="3 6 9 3 15 6 21 3 21 21 15 18 9 21 3 18 3 6"/></svg>
            Itinéraire
          </div>

          <div class="vd-journey" style="margin-bottom:20px">
            <div class="vd-journey-stop vd-journey-stop-depart">
              <div class="vd-journey-node vd-journey-node-depart">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
              </div>
              <div class="vd-journey-info">
                <span class="vd-journey-badge vd-journey-badge-depart">{{ estTypeInterurbain() ? 'Départ' : 'Enlèvement' }}</span>
                <p class="vd-journey-addr">{{ commandeForm.get('lieuDepartTexte')?.value || '—' }}</p>
              </div>
            </div>
            <div class="vd-journey-track">
              <div class="vd-journey-track-fill"></div>
              <div class="vd-journey-track-vehicle">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="15" height="15"><path d="M17.657 5.304c-3.124-3.073-8.189-3.073-11.313 0a7.78 7.78 0 0 0 0 11.13L12 21.999l5.657-5.565a7.78 7.78 0 0 0 0-11.13zM12 13.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>
              </div>
            </div>
            <div class="vd-journey-stop vd-journey-stop-arrivee">
              <div class="vd-journey-node vd-journey-node-arrivee">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6z"/></svg>
              </div>
              <div class="vd-journey-info">
                <span class="vd-journey-badge vd-journey-badge-arrivee">{{ estTypeInterurbain() ? 'Destination' : 'Livraison' }}</span>
                <p class="vd-journey-addr">{{ commandeForm.get('lieuArriveeTexte')?.value || '—' }}</p>
              </div>
            </div>
          </div>

          <div class="cmd-block__sub-hdr">Personnes impliquées</div>
          <div class="cmd-parties">
            <div class="cmd-party">
              <span class="cmd-party__avatar">{{ (commandeDetail?.expediteurNom || 'E').charAt(0).toUpperCase() }}</span>
              <div class="cmd-party__info">
                <span class="cmd-party__role">Expéditeur</span>
                <strong class="cmd-party__name">{{ commandeDetail?.expediteurNom || commandeForm.getRawValue().expediteurNom || '—' }}</strong>
                <a *ngIf="commandeDetail?.expediteurContact || commandeForm.getRawValue().expediteurContact"
                   [href]="'tel:' + (commandeDetail?.expediteurContact || commandeForm.getRawValue().expediteurContact)"
                   class="cmd-party__tel">{{ commandeDetail?.expediteurContact || commandeForm.getRawValue().expediteurContact }}</a>
              </div>
            </div>
            <div class="cmd-parties__arrow">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="2" width="20" height="20"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </div>
            <div class="cmd-party">
              <span class="cmd-party__avatar cmd-party__avatar--dest">{{ (commandeDetail?.destinataireNom || 'D').charAt(0).toUpperCase() }}</span>
              <div class="cmd-party__info">
                <span class="cmd-party__role">Destinataire</span>
                <strong class="cmd-party__name">{{ commandeDetail?.destinataireNom || commandeForm.getRawValue().destinataireNom || '—' }}</strong>
                <a *ngIf="commandeDetail?.destinataireContact || commandeForm.getRawValue().destinataireContact"
                   [href]="'tel:' + (commandeDetail?.destinataireContact || commandeForm.getRawValue().destinataireContact)"
                   class="cmd-party__tel">{{ commandeDetail?.destinataireContact || commandeForm.getRawValue().destinataireContact }}</a>
              </div>
            </div>
          </div>

          <div class="cmd-block__sub-hdr" style="margin-top:16px">Détails</div>
          <div class="cmd-prestation-chips">
            <span *ngIf="commandeForm.value.modePaiement" class="cmd-chip cmd-chip--blue">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
              {{ obtenirLibelle(modePaiementOptions, commandeForm.value.modePaiement) }}
            </span>
            <span *ngIf="commandeForm.get('dateEnlevementPrev')?.value" class="cmd-chip cmd-chip--violet">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              {{ commandeForm.get('dateEnlevementPrev')?.value | date:'dd/MM/yyyy' }}<ng-container *ngIf="commandeForm.get('heureEnlevementPrev')?.value"> · {{ commandeForm.get('heureEnlevementPrev')?.value | date:'HH:mm' }}</ng-container>
            </span>
            <span *ngIf="commandeDetail.dateLivraison" class="cmd-chip" style="background:#f0fdf4;color:#059669">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>
              Livré le {{ commandeDetail.dateLivraison | date:'dd MMM yyyy' }}
            </span>
          </div>
        </div><!-- /cmd-block--route -->

        <!-- Articles -->
        <div class="cmd-articles-section">
          <div class="cmd-articles-hdr">
            <div class="cmd-articles-hdr__left">
              <h3 class="cmd-articles-hdr__title">Articles</h3>
              <span class="cmd-articles-hdr__count">{{ articlesCmd?.controls?.length || 0 }} article(s)</span>
            </div>
            <div class="cmd-articles-hdr__actions" *ngIf="commandeId">
              <ng-container *ngIf="!modeEditionArticles">
                <button *ngIf="peutModifierArticles()" type="button" class="cmd-btn-edit" (click)="activerEditionArticles()">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  Modifier
                </button>
              </ng-container>
              <ng-container *ngIf="modeEditionArticles">
                <button type="button" class="btn btn-secondary" style="padding:5px 12px;font-size:12px" (click)="annulerEditionArticles()" [disabled]="sauvegarderArticlesEnCours">Annuler</button>
                <button type="button" class="btn btn-primary" style="padding:5px 12px;font-size:12px;margin-left:6px" (click)="sauvegarderArticles()" [disabled]="sauvegarderArticlesEnCours">
                  {{ sauvegarderArticlesEnCours ? 'Enregistrement...' : 'Sauvegarder' }}
                </button>
              </ng-container>
            </div>
          </div>

          <ng-container *ngIf="!modeEditionArticles">

            <!-- Article track list -->
            <div class="cmd-art-track" *ngIf="articlesCmd?.controls?.length; else noArt">
              <div class="cmd-art-row" *ngFor="let ctrl of articlesCmd.controls; let i = index; let last = last" [style.--idx]="i">
                <!-- connector between rows -->
                <div class="cmd-art-row__thread" *ngIf="!last"></div>
                <!-- icon node -->
                <div class="cmd-art-row__node">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="15" height="15"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
                </div>
                <!-- main content -->
                <div class="cmd-art-row__body">
                  <span class="cmd-art-row__type">{{ ctrl.get('typeArticle')?.value || 'Colis' }}</span>
                  <span class="cmd-art-row__desc">{{ ctrl.get('description')?.value || '—' }}</span>
                </div>
                <!-- chips -->
                <div class="cmd-art-row__chips">
                  <span *ngIf="ctrl.get('poids')?.value" class="cmd-art-chip">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" width="9" height="9"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>
                    {{ ctrl.get('poids')?.value }} kg
                  </span>
                  <span *ngIf="ctrl.get('longueur')?.value" class="cmd-art-chip">{{ ctrl.get('longueur')?.value }}×{{ ctrl.get('largeur')?.value }} cm</span>
                </div>
                <!-- qty + price -->
                <div class="cmd-art-row__right">
                  <span class="cmd-art-row__qty">×{{ ctrl.get('quantite')?.value || 1 }}</span>
                  <span class="cmd-art-row__price">{{ ctrl.get('montantForfait')?.value | number:'1.0-0' }}<small>FCFA</small></span>
                </div>
              </div>
            </div>
            <ng-template #noArt>
              <div class="cmd-articles-empty">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="32" height="32"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
                Aucun article enregistré
              </div>
            </ng-template>

            <!-- Finance compact bar -->
            <div class="cmd-finance-compact">
              <div class="cmd-finance-compact__item" style="--fi:0">
                <span class="cmd-finance-compact__lbl">Forfait</span>
                <span class="cmd-finance-compact__val">{{ commandeForm.value['montantTotalForfait'] | number:'1.0-0' }}<small>FCFA</small></span>
              </div>
              <div class="cmd-finance-compact__sep" *ngIf="commandeForm.value['montantTotalSupplementaire']">+</div>
              <div class="cmd-finance-compact__item" *ngIf="commandeForm.value['montantTotalSupplementaire']" style="--fi:1">
                <span class="cmd-finance-compact__lbl">Supplément</span>
                <span class="cmd-finance-compact__val">{{ commandeForm.value['montantTotalSupplementaire'] | number:'1.0-0' }}<small>FCFA</small></span>
              </div>
              <div class="cmd-finance-compact__sep cmd-finance-compact__sep--remise" *ngIf="commandeForm.value['montantRemise']">−</div>
              <div class="cmd-finance-compact__item cmd-finance-compact__item--remise" *ngIf="commandeForm.value['montantRemise']" style="--fi:2">
                <span class="cmd-finance-compact__lbl">Remise</span>
                <span class="cmd-finance-compact__val cmd-finance-compact__val--remise">{{ commandeForm.value['montantRemise'] | number:'1.0-0' }}<small>FCFA</small></span>
              </div>
              <div class="cmd-finance-compact__total">
                <span class="cmd-finance-compact__total-lbl">Total</span>
                <span class="cmd-finance-compact__total-val">{{ commandeForm.value['montantTotalForfait'] + commandeForm.value['montantTotalSupplementaire'] - (commandeForm.value['montantRemise'] || 0) | number:'1.0-0' }}<small>FCFA</small></span>
              </div>
            </div>

          </ng-container>

          <ng-container *ngIf="modeEditionArticles">
            <app-data-product
              [displayedColumns]="colonnesAffichees"
              [parentForm]="commandeForm"
              [isViewMode]="false"
              (articleAjoute)="onArticleAjoute()"
              (articleSupprime)="onArticleSupprime($event)"
              (articleModifie)="onArticleModifie($event)">
            </app-data-product>
          </ng-container>
        </div><!-- /cmd-articles-section -->

      </div><!-- /cmd-main -->

      <!-- Colonne latérale -->
      <div class="cmd-aside">

        <!-- Livreur -->
        <div class="cmd-block">
          <div class="cmd-block__hdr">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 1 0-16 0"/></svg>
            Équipe
          </div>
          <ng-container *ngIf="commandeDetail.livreurNom; else noLivreur">
            <div class="cdv-livreur">
              <div class="cdv-livreur__av">
                {{ obtenirInitialesLivreur(commandeDetail.livreurNom) }}
                <span class="cdv-livreur__pulse" *ngIf="['AFFECTE','EN_PREPARATION','EN_LIVRAISON'].includes(commandeDetail.statut)"></span>
              </div>
              <div class="cdv-livreur__info">
                <strong class="cdv-livreur__name">{{ commandeDetail.livreurNom }}</strong>
                <span class="cdv-livreur__role">Livreur assigné</span>
              </div>
            </div>
            <a *ngIf="commandeDetail.telephoneLivreur"
               [href]="'tel:' + commandeDetail.telephoneLivreur"
               class="cdv-tel-btn">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.35 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.72a16 16 0 0 0 6 6l.97-.97a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 21.5 16z"/></svg>
              {{ commandeDetail.telephoneLivreur }}
            </a>
            <div class="cdv-livreur__stats" *ngIf="commandeDetail.livreurNbLivraisons != null || commandeDetail.livreurTauxSucces != null">
              <span>{{ commandeDetail.livreurNbLivraisons ?? '—' }} livraisons</span>
              <span *ngIf="commandeDetail.livreurTauxSucces != null" class="cdv-livreur__rate">{{ commandeDetail.livreurTauxSucces }}% succès</span>
            </div>
          </ng-container>
          <ng-template #noLivreur>
            <div class="cdv-no-livreur">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="1.5" width="32" height="32"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 1 0-16 0"/></svg>
              <span>Aucun livreur assigné</span>
            </div>
          </ng-template>

          <div class="cdv-sep"></div>
          <div class="cdv-incidents-header">
            <span>Incidents</span>
            <span class="cdv-incidents-badge" *ngIf="incidentsCommande.length > 0">{{ incidentsCommande.length }}</span>
          </div>
          <div *ngIf="incidentsEnChargement" class="incidents-loading" style="font-size:12px"><div class="spinner-sm"></div> Chargement...</div>
          <div *ngIf="!incidentsEnChargement && incidentsCommande.length === 0" class="cdv-incidents-empty">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2" width="14" height="14"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
            Aucun incident
          </div>
          <div *ngFor="let incident of incidentsCommande" class="incident-item" style="margin-top:8px">
            <div class="incident-item-header">
              <span class="incident-type-label">{{ obtenirLibelleTypeIncident(incident.type) }}</span>
              <span class="incident-badge" [ngClass]="obtenirClasseStatutIncident(incident.statut)">{{ incident.statut }}</span>
            </div>
            <p class="incident-desc" *ngIf="incident.description">{{ incident.description }}</p>
            <div class="incident-resolution" *ngIf="incident.resolution">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" width="10" height="10"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              {{ incident.resolution }}
            </div>
          </div>

          <ng-container *ngIf="commandeDetail?.estSatisfaction">
            <div class="cdv-sep"></div>
            <div class="cdv-incidents-header">Avis client</div>
            <div class="avis-stars" style="margin-top:8px">
              <ng-container *ngFor="let e of obtenirEtoilesNote(commandeDetail.noteSatisfactionClient || 0)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"
                     [attr.fill]="e === 'filled' ? '#f59e0b' : 'none'"
                     [attr.stroke]="e === 'filled' ? '#f59e0b' : '#d1d5db'" stroke-width="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </ng-container>
              <span class="avis-note-val" style="font-size:12px">{{ commandeDetail.noteSatisfactionClient }}/5</span>
            </div>
            <p class="avis-commentaire" *ngIf="commandeDetail.commentaireSatisfaction">"{{ commandeDetail.commentaireSatisfaction }}"</p>
          </ng-container>
        </div><!-- /livreur block -->

        <!-- Carte GPS -->
        <div class="cmd-block cmd-aside__map-block" *ngIf="commandeId && commandeDetail?.livreurNom" (click)="ouvrirSheetCarte()" style="cursor:pointer;padding:0;overflow:hidden">
          <div style="display:flex;align-items:center;justify-content:space-between;padding:14px 18px;border-bottom:1px solid #f3f4f6">
            <span style="font-size:13px;font-weight:700;color:#111827;display:flex;align-items:center;gap:6px">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#0d9488" stroke-width="2" width="14" height="14"><polygon points="3 6 9 3 15 6 21 3 21 21 15 18 9 21 3 18 3 6"/></svg>
              Suivi GPS
              <span class="vd-live-badge" *ngIf="['AFFECTE','EN_PREPARATION','EN_LIVRAISON'].includes(commandeDetail?.statut || '')"><span class="live-dot"></span>LIVE</span>
            </span>
            <span style="font-size:11px;color:#0d9488;background:#f0fdfa;padding:3px 9px;border-radius:6px;border:1px solid #99f6e4;font-weight:600">Agrandir</span>
          </div>
          <div class="cdv-map-wrap" style="height:180px;border-radius:0">
            <app-tracking-map
              *ngIf="!carteSheetVisible"
              [commandeId]="commandeId"
              [departLat]="commandeForm.get('lieuDepartLatitude')?.value"
              [departLng]="commandeForm.get('lieuDepartLongitude')?.value"
              [arriveeLat]="commandeForm.get('lieuArriveeLatitude')?.value"
              [arriveeLng]="commandeForm.get('lieuArriveeLongitude')?.value"
              [departTexte]="commandeForm.get('lieuDepartTexte')?.value"
              [arriveeTexte]="commandeForm.get('lieuArriveeTexte')?.value"
              [statut]="commandeDetail?.statut">
            </app-tracking-map>
            <div *ngIf="carteSheetVisible" class="vd-map-preview-placeholder">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#0d9488" stroke-width="1.5" width="28" height="28"><polygon points="3 6 9 3 15 6 21 3 21 21 15 18 9 21 3 18 3 6"/></svg>
              <span>Carte agrandie ouverte</span>
            </div>
          </div>
        </div><!-- /carte -->

      </div><!-- /cmd-aside -->
    </div><!-- /cmd-bento-r1 -->

    <!-- ══ BOTTOM ROW : Chronologie + Photos + Notes ══ -->
    <div class="cmd-bento-r3">

      <!-- Chronologie -->
      <div class="cmd-block cmd-block--dates">
        <div class="cmd-block__hdr">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          Chronologie
        </div>

        <div class="cmd-timeline">

          <!-- Commande passée -->
          <div class="cmd-tl-item cmd-tl-item--blue" [class.cmd-tl-item--done]="obtenirDatePassage()" style="--ti:0">
            <div class="cmd-tl-item__track">
              <div class="cmd-tl-item__node">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              </div>
              <div class="cmd-tl-item__line"></div>
            </div>
            <div class="cmd-tl-item__content">
              <span class="cmd-tl-item__lbl">Commande passée</span>
              <ng-container *ngIf="obtenirDatePassage(); else noDateTpl">
                <span class="cmd-tl-item__date">{{ obtenirDatePassage() | date:'dd MMM yyyy' }}</span>
                <span class="cmd-tl-item__time">{{ obtenirDatePassage() | date:'HH:mm' }}</span>
              </ng-container>
            </div>
          </div>

          <!-- Enlèvement -->
          <div class="cmd-tl-item cmd-tl-item--teal" [class.cmd-tl-item--done]="commandeDetail.dateEnlevement" style="--ti:1">
            <div class="cmd-tl-item__track">
              <div class="cmd-tl-item__node">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </div>
              <div class="cmd-tl-item__line"></div>
            </div>
            <div class="cmd-tl-item__content">
              <span class="cmd-tl-item__lbl">Enlèvement</span>
              <ng-container *ngIf="commandeDetail.dateEnlevement; else noDateTpl">
                <span class="cmd-tl-item__date">{{ commandeDetail.dateEnlevement | date:'dd MMM yyyy' }}</span>
                <span class="cmd-tl-item__time">{{ commandeDetail.dateEnlevement | date:'HH:mm' }}</span>
              </ng-container>
            </div>
          </div>

          <!-- Étapes interurbain standard -->
          <ng-container *ngIf="commandeDetail.typeEnvoi === 'STANDARD_INTERURBAIN'">

            <!-- Récupération -->
            <div class="cmd-tl-item cmd-tl-item--teal" [class.cmd-tl-item--done]="commandeDetail.dateRecuperation" style="--ti:2">
              <div class="cmd-tl-item__track">
                <div class="cmd-tl-item__node">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
                </div>
                <div class="cmd-tl-item__line"></div>
              </div>
              <div class="cmd-tl-item__content">
                <span class="cmd-tl-item__lbl">Récupération</span>
                <ng-container *ngIf="commandeDetail.dateRecuperation; else noDateTpl">
                  <span class="cmd-tl-item__date">{{ commandeDetail.dateRecuperation | date:'dd MMM yyyy' }}</span>
                  <span class="cmd-tl-item__time">{{ commandeDetail.dateRecuperation | date:'HH:mm' }}</span>
                </ng-container>
              </div>
            </div>

            <!-- Au dépôt -->
            <div class="cmd-tl-item cmd-tl-item--teal" [class.cmd-tl-item--done]="commandeDetail.dateDepot" style="--ti:3">
              <div class="cmd-tl-item__track">
                <div class="cmd-tl-item__node">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>
                </div>
                <div class="cmd-tl-item__line"></div>
              </div>
              <div class="cmd-tl-item__content">
                <span class="cmd-tl-item__lbl">Au dépôt</span>
                <ng-container *ngIf="commandeDetail.dateDepot; else noDateTpl">
                  <span class="cmd-tl-item__date">{{ commandeDetail.dateDepot | date:'dd MMM yyyy' }}</span>
                  <span class="cmd-tl-item__time">{{ commandeDetail.dateDepot | date:'HH:mm' }}</span>
                </ng-container>
              </div>
            </div>

            <!-- En tri -->
            <div class="cmd-tl-item cmd-tl-item--teal" [class.cmd-tl-item--done]="commandeDetail.dateTri" style="--ti:4">
              <div class="cmd-tl-item__track">
                <div class="cmd-tl-item__node">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><polyline points="16 3 21 8 8 21"/><line x1="2" y1="21" x2="21" y2="21"/><polyline points="7 21 2 16"/><line x1="13" y1="15" x2="21" y2="15"/></svg>
                </div>
                <div class="cmd-tl-item__line"></div>
              </div>
              <div class="cmd-tl-item__content">
                <span class="cmd-tl-item__lbl">En tri</span>
                <ng-container *ngIf="commandeDetail.dateTri; else noDateTpl">
                  <span class="cmd-tl-item__date">{{ commandeDetail.dateTri | date:'dd MMM yyyy' }}</span>
                  <span class="cmd-tl-item__time">{{ commandeDetail.dateTri | date:'HH:mm' }}</span>
                </ng-container>
              </div>
            </div>

            <!-- En transit -->
            <div class="cmd-tl-item cmd-tl-item--teal" [class.cmd-tl-item--done]="commandeDetail.dateTransit" style="--ti:5">
              <div class="cmd-tl-item__track">
                <div class="cmd-tl-item__node">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
                </div>
                <div class="cmd-tl-item__line"></div>
              </div>
              <div class="cmd-tl-item__content">
                <span class="cmd-tl-item__lbl">En transit</span>
                <ng-container *ngIf="commandeDetail.dateTransit; else noDateTpl">
                  <span class="cmd-tl-item__date">{{ commandeDetail.dateTransit | date:'dd MMM yyyy' }}</span>
                  <span class="cmd-tl-item__time">{{ commandeDetail.dateTransit | date:'HH:mm' }}</span>
                </ng-container>
              </div>
            </div>

            <!-- Réceptionné -->
            <div class="cmd-tl-item cmd-tl-item--teal" [class.cmd-tl-item--done]="commandeDetail.dateReception" style="--ti:6">
              <div class="cmd-tl-item__track">
                <div class="cmd-tl-item__node">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
                </div>
                <div class="cmd-tl-item__line"></div>
              </div>
              <div class="cmd-tl-item__content">
                <span class="cmd-tl-item__lbl">Réceptionné</span>
                <ng-container *ngIf="commandeDetail.dateReception; else noDateTpl">
                  <span class="cmd-tl-item__date">{{ commandeDetail.dateReception | date:'dd MMM yyyy' }}</span>
                  <span class="cmd-tl-item__time">{{ commandeDetail.dateReception | date:'HH:mm' }}</span>
                </ng-container>
              </div>
            </div>

            <!-- En distribution -->
            <div class="cmd-tl-item cmd-tl-item--teal" [class.cmd-tl-item--done]="commandeDetail.dateDistribution" style="--ti:7">
              <div class="cmd-tl-item__track">
                <div class="cmd-tl-item__node">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>
                </div>
                <div class="cmd-tl-item__line"></div>
              </div>
              <div class="cmd-tl-item__content">
                <span class="cmd-tl-item__lbl">En distribution</span>
                <ng-container *ngIf="commandeDetail.dateDistribution; else noDateTpl">
                  <span class="cmd-tl-item__date">{{ commandeDetail.dateDistribution | date:'dd MMM yyyy' }}</span>
                  <span class="cmd-tl-item__time">{{ commandeDetail.dateDistribution | date:'HH:mm' }}</span>
                </ng-container>
              </div>
            </div>

          </ng-container>

          <!-- Livraison -->
          <div class="cmd-tl-item cmd-tl-item--green" [class.cmd-tl-item--done]="commandeDetail.dateLivraison"
               [style.--ti]="commandeDetail.typeEnvoi === 'STANDARD_INTERURBAIN' ? 8 : 2">
            <div class="cmd-tl-item__track">
              <div class="cmd-tl-item__node">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
            </div>
            <div class="cmd-tl-item__content">
              <span class="cmd-tl-item__lbl">Livraison</span>
              <ng-container *ngIf="commandeDetail.dateLivraison; else noDateTpl">
                <span class="cmd-tl-item__date cmd-tl-item__date--success">{{ commandeDetail.dateLivraison | date:'dd MMM yyyy' }}</span>
                <span class="cmd-tl-item__time">{{ commandeDetail.dateLivraison | date:'HH:mm' }}</span>
              </ng-container>
            </div>
          </div>

          <ng-template #noDateTpl>
            <span class="cmd-tl-item__pending">En attente</span>
          </ng-template>

        </div>
      </div>

      <!-- Photos -->
      <div class="cmd-block cmd-block--photos">
        <div class="cmd-block__hdr">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
          Photos
        </div>
        <!-- inputs fichier cachés par étape -->
        <input #fileRecuperation type="file" accept="image/*" style="display:none"
               (change)="onFichierProcessSelectionne('RECUPERATION', $event); uploaderPhotoProcess('RECUPERATION')" />
        <input #fileExpedition type="file" accept="image/*" style="display:none"
               (change)="onFichierProcessSelectionne('EXPEDITION_CENTRE', $event); uploaderPhotoProcess('EXPEDITION_CENTRE')" />
        <input #fileReception type="file" accept="image/*" style="display:none"
               (change)="onFichierProcessSelectionne('RECEPTION_CENTRE', $event); uploaderPhotoProcess('RECEPTION_CENTRE')" />
        <input #fileLivraison type="file" accept="image/*" style="display:none"
               (change)="onFichierProcessSelectionne('LIVRAISON', $event); uploaderPhotoProcess('LIVRAISON')" />

        <div class="cdv-photos-grid">
          <ng-container *ngFor="let etape of photosProcessTimeline(); let i = index">
            <div class="cdv-photo-thumb"
                 [class.cdv-photo-thumb--has]="etape.url"
                 [class.cdv-photo-thumb--uploadable]="!etape.url"
                 [style.--pi]="i"
                 (click)="etape.url ? ouvrirPhotoTimeline(i) : declencherUploadPhoto(etape.cle, fileRecuperation, fileExpedition, fileReception, fileLivraison)"
                 [title]="etape.url ? etape.label : 'Cliquer pour ajouter la photo — ' + etape.label">

              <!-- filled -->
              <ng-container *ngIf="etape.url">
                <img [src]="urlPhoto(etape.url || '')" [alt]="etape.label" />
                <div class="cdv-photo-thumb__overlay">
                  <span class="cdv-photo-thumb__lbl">{{ etape.label }}</span>
                </div>
              </ng-container>

              <!-- empty — cliquable pour upload -->
              <ng-container *ngIf="!etape.url">
                <div class="cdv-photo-thumb__empty">
                  <div class="cdv-photo-thumb__icon-wrap">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="20" height="20"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
                  </div>
                  <span class="cdv-photo-thumb__lbl">{{ etape.label }}</span>
                  <span style="font-size:10px;color:var(--teal,#14b8a6);margin-top:4px">+ Ajouter</span>
                </div>
              </ng-container>

              <!-- step badge -->
              <span class="cdv-photo-thumb__step">{{ i + 1 }}</span>
            </div>
          </ng-container>
        </div>
        <p *ngIf="photoLivraisonErreurChargement" class="photo-error-hint" style="font-size:11px;margin-top:8px;color:#ef4444">Erreur chargement photo</p>
      </div>

      <!-- Notes -->
      <div class="cmd-block cmd-block--remarks">
        <div class="cmd-block__hdr">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          Notes
        </div>

        <!-- Remarques client -->
        <div class="cmd-note-card cmd-note-card--blue" style="--ri:0">
          <div class="cmd-note-card__header">
            <div class="cmd-note-card__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <span class="cmd-note-card__lbl">Remarques client</span>
          </div>
          <p class="cmd-note-card__val" [class.cmd-note-card__val--empty]="!commandeForm.get('observations')?.value">
            {{ commandeForm.get('observations')?.value || 'Aucune remarque renseignée' }}
          </p>
        </div>

        <!-- Instructions spéciales -->
        <div class="cmd-note-card cmd-note-card--amber" style="--ri:1" *ngIf="commandeDetail?.exigencesClient">
          <div class="cmd-note-card__header">
            <div class="cmd-note-card__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" width="12" height="12"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            </div>
            <span class="cmd-note-card__lbl">Instructions spéciales</span>
          </div>
          <p class="cmd-note-card__val">{{ commandeDetail.exigencesClient }}</p>
        </div>

      </div>

    </div><!-- /cmd-bento-r3 -->

  </div><!-- /cmd-page -->

  <!-- ══ FLOATING ACTIONS BAR — hors de cmd-page pour éviter le containing block du transform ══ -->
  <div class="cmd-actions-bar">
    <a [routerLink]="'/commande/lister'" class="cmd-action-btn cmd-action-btn--back">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
      Retour
    </a>
    <div class="cmd-actions-bar__right">
      <ng-container *ngIf="estLivreur()">
        <button *ngIf="commandeForm.value.statut === 'AFFECTE'"
                type="button" class="cmd-action-btn cmd-action-btn--primary"
                (click)="changerStatutLivreur('EN_LIVRAISON')" [disabled]="estEnChargement">
          En livraison
        </button>
        <button *ngIf="commandeForm.value.statut === 'EN_LIVRAISON'"
                type="button" class="cmd-action-btn cmd-action-btn--success"
                (click)="changerStatutLivreur('LIVRE')" [disabled]="estEnChargement">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg>
          Marquer livrée
        </button>
      </ng-container>
      <ng-container *ngIf="!estLivreur()">
        <button *ngIf="commandeDetail.statut !== 'LIVRE' && commandeDetail.statut !== 'ANNULE'"
                type="button"
                [class]="commandeDetail.livreurNom ? 'cmd-action-btn cmd-action-btn--warning' : 'cmd-action-btn cmd-action-btn--assign'"
                (click)="ouvrirPanelAffectationLivreur()" [disabled]="estEnChargement">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 1 0-16 0"/><line x1="19" y1="8" x2="23" y2="8"/><line x1="21" y1="6" x2="21" y2="10"/></svg>
          {{ commandeDetail.livreurNom ? 'Modifier le livreur' : 'Affecter un livreur' }}
        </button>
        <button type="button" class="cmd-action-btn cmd-action-btn--primary"
                [disabled]="!peutModifierCommande()"
                (click)="activerModeEdition()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
          Modifier
        </button>
      </ng-container>
    </div>
  </div>
  </ng-container>

  <!-- Aperçu photo grand format -->
  <div class="photo-preview-backdrop"
       *ngIf="photoApercuUrl"
       (click)="fermerPhotoPleinEcran()">
    <div class="photo-preview-modal" (click)="$event.stopPropagation()">
      <button type="button" class="photo-preview-close" (click)="fermerPhotoPleinEcran()">✕</button>
      <button *ngIf="photoApercuIndex >= 0" type="button" class="photo-preview-nav photo-preview-nav--prev" (click)="photoTimelinePrecedente()">‹</button>
      <button *ngIf="photoApercuIndex >= 0" type="button" class="photo-preview-nav photo-preview-nav--next" (click)="photoTimelineSuivante()">›</button>
      <img [src]="photoApercuUrl" alt="Aperçu photo" class="photo-preview-image" />
    </div>
  </div>

  <!-- EDIT MODE: Form -->
  <form class="form-container" [class.edit-mode]="!estModeConsultation" [formGroup]="commandeForm" (ngSubmit)="onSubmit()" *ngIf="!estModeConsultation">
    <div class="form-section">
      <h3 class="form-section-title">Client</h3>
      <div class="form-row">
        <div class="form-group">
          <label class="form-label">Client (optionnel)</label>
          <div class="client-chosen-wrapper"
               [class.client-chosen-open]="dropdownClientOuvert"
               [class.client-chosen-has-value]="!!clientSelectionne"
               (click)="$event.stopPropagation()">

            <!-- Trigger -->
            <div class="client-chosen-trigger"
                 (click)="toggleDropdownClient($event)"
                 tabindex="0"
                 role="combobox"
                 [attr.aria-expanded]="dropdownClientOuvert"
                 (keydown.enter)="toggleDropdownClient($event)"
                 (keydown.escape)="fermerDropdownClient()">
              <div class="client-chosen-value">
                <ng-container *ngIf="clientSelectionne; else clientVide">
                  <span class="client-chosen-tag">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    <span class="client-chosen-tag__name">{{ clientSelectionne.nom }} {{ clientSelectionne.prenom }}</span>
                    <span class="client-chosen-tag__type">{{ clientSelectionne.typeUtilisateurLibelle || clientSelectionne.typeUtilisateur }}</span>
                    <button type="button" class="client-chosen-clear" (click)="effacerClient($event)" title="Effacer">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" width="11" height="11"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                  </span>
                </ng-container>
                <ng-template #clientVide>
                  <span class="client-chosen-placeholder">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                    Rechercher un client...
                  </span>
                </ng-template>
              </div>
              <svg class="client-chosen-caret" [class.client-chosen-caret-up]="dropdownClientOuvert"
                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>

            <!-- Dropdown -->
            <div class="client-chosen-dropdown" *ngIf="dropdownClientOuvert" role="listbox">
              <div class="client-chosen-search">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="15" height="15" class="client-chosen-search__icon"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                <input class="client-chosen-search__input"
                       type="text"
                       placeholder="Nom, prénom ou type..."
                       [(ngModel)]="rechercheClient"
                       [ngModelOptions]="{standalone: true}"
                       (input)="filtrerClients()"
                       (click)="$event.stopPropagation()"
                       autofocus />
              </div>
              <ul class="client-chosen-list" role="listbox">
                <li *ngIf="clientsFiltres.length === 0" class="client-chosen-empty">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="16" height="16"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                  Aucun client trouvé
                </li>
                <li *ngFor="let c of clientsFiltres"
                    class="client-chosen-item"
                    [class.client-chosen-item--selected]="clientSelectionne?.id === c.id"
                    (click)="selectionnerClient(c)"
                    role="option"
                    [attr.aria-selected]="clientSelectionne?.id === c.id">
                  <div class="client-chosen-item__avatar">{{ (c.nom || '?').charAt(0).toUpperCase() }}{{ (c.prenom || '').charAt(0).toUpperCase() }}</div>
                  <div class="client-chosen-item__info">
                    <span class="client-chosen-item__name">{{ c.nom }} {{ c.prenom }}</span>
                    <span class="client-chosen-item__type">{{ c.typeUtilisateurLibelle || c.typeUtilisateur }}</span>
                  </div>
                  <svg *ngIf="clientSelectionne?.id === c.id" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" width="14" height="14" class="client-chosen-item__check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </li>
              </ul>
              <div class="client-chosen-footer" *ngIf="clientsOptions.length > 0">
                {{ clientsFiltres.length }} / {{ clientsOptions.length }} client(s)
              </div>
            </div>
          </div>
          <input type="hidden" formControlName="clientId" />
        </div>
      </div>
      <div class="form-row" *ngIf="typeClientSelectionne() === 'CLIENT SOUS CONTRAT'">
        <div class="form-group">
          <label class="form-label">Contrat de tarification</label>
          <select class="form-select" formControlName="contratBaseTarification">
            <option value="">Sélectionner une base</option>
            <option value="METHODE_ACTUELLE">Poids brut + poids volumétrique (méthode actuelle)</option>
            <option value="PARTICULIERE">Tarification particulière</option>
          </select>
        </div>
        <div class="form-group" *ngIf="commandeForm.get('contratBaseTarification')?.value === 'PARTICULIERE'">
          <label class="form-label">Détails de tarification particulière</label>
          <input class="form-input" type="text" formControlName="contratTarificationParticuliere" placeholder="Ex: Forfait mensuel 500 000 F">
        </div>
      </div>
    </div>

    <div class="form-section" *ngIf="commandeId">
      <h3 class="form-section-title">Preuves photo process</h3>
      <p style="color: var(--text-secondary); font-size: 13px; margin-bottom: 12px;">
        Interurbain standard: récupération, expédition centre, réception centre, livraison. Interurbain express: récupération + livraison.
      </p>

      <div class="form-row">
        <div class="form-group">
          <label class="form-label">Photo récupération</label>
          <input type="file" class="form-input" (change)="onFichierProcessSelectionne('RECUPERATION', $event)" />
          <button type="button" class="btn btn-secondary" style="margin-top:8px;" (click)="uploaderPhotoProcess('RECUPERATION')" [disabled]="uploadProcessEnCours['RECUPERATION']">
            {{ uploadProcessEnCours['RECUPERATION'] ? 'Upload...' : 'Uploader récupération' }}
          </button>
        </div>
        <div class="form-group" *ngIf="estInterurbainStandardSelectionne()">
          <label class="form-label">Photo expédition centre</label>
          <input type="file" class="form-input" (change)="onFichierProcessSelectionne('EXPEDITION_CENTRE', $event)" />
          <button type="button" class="btn btn-secondary" style="margin-top:8px;" (click)="uploaderPhotoProcess('EXPEDITION_CENTRE')" [disabled]="uploadProcessEnCours['EXPEDITION_CENTRE']">
            {{ uploadProcessEnCours['EXPEDITION_CENTRE'] ? 'Upload...' : 'Uploader expédition centre' }}
          </button>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group" *ngIf="estInterurbainStandardSelectionne()">
          <label class="form-label">Photo réception centre destination</label>
          <input type="file" class="form-input" (change)="onFichierProcessSelectionne('RECEPTION_CENTRE', $event)" />
          <button type="button" class="btn btn-secondary" style="margin-top:8px;" (click)="uploaderPhotoProcess('RECEPTION_CENTRE')" [disabled]="uploadProcessEnCours['RECEPTION_CENTRE']">
            {{ uploadProcessEnCours['RECEPTION_CENTRE'] ? 'Upload...' : 'Uploader réception centre' }}
          </button>
        </div>
        <div class="form-group">
          <label class="form-label">Photo preuve livraison</label>
          <input type="file" class="form-input" (change)="onFichierProcessSelectionne('LIVRAISON', $event)" />
          <button type="button" class="btn btn-secondary" style="margin-top:8px;" (click)="uploaderPhotoProcess('LIVRAISON')" [disabled]="uploadProcessEnCours['LIVRAISON']">
            {{ uploadProcessEnCours['LIVRAISON'] ? 'Upload...' : 'Uploader preuve livraison' }}
          </button>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div style="display:flex;align-items:center;gap:10px;margin-bottom:8px;">
        <h3 class="form-section-title" style="margin:0">Type de Prestation</h3>
        <span *ngIf="modeCommande === 'interurbain'"
              style="background:#e0f7f4;color:#00796b;padding:3px 12px;border-radius:20px;font-size:12px;font-weight:600;">
          <i class="fal fa-route"></i> Interurbain uniquement
        </span>
        <span *ngIf="modeCommande === 'urbain'"
              style="background:#e3f2fd;color:#1565c0;padding:3px 12px;border-radius:20px;font-size:12px;font-weight:600;">
          <i class="fal fa-city"></i> Urbain uniquement
        </span>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label class="form-label">Type de Prestation *</label>
          <select class="form-select" formControlName="typeEnvoi">
            <option value="">Sélectionner le Type de Prestation</option>
            <option *ngFor="let te of typeEnvoiOptions" [value]="te.value">{{te.label}}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">Mode de Paiement *</label>
          <select class="form-select" formControlName="modePaiement">
            <option value="">Sélectionner le Mode de Paiement</option>
            <option *ngFor="let mp of modePaiementOptions" [value]="mp.value">{{mp.label}}</option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label class="form-label">Date d'Enlèvement Prévisionnelle *</label>
          <div class="date-input-group">
            <input
              type="text"
              class="form-input"
              [matDatepicker]="pickerA"
              formControlName="dateEnlevementPrev"
              placeholder="JJ/MM/AAAA"
              [min]="dateMinEnlevement"
              readonly>
            <button
              type="button"
              class="date-picker-btn"
              (click)="pickerA.open()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </button>
            <mat-datepicker #pickerA></mat-datepicker>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Heure d'Enlèvement Prévisionnelle *</label>
          <input class="form-input" type="time" formControlName="heureEnlevementPrev" placeholder="--:--">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label class="form-label">Moyen de Transport *</label>
          <select class="form-select" formControlName="moyenTransport">
            <option value="">Sélectionner le Moyen de Transport</option>
            <option *ngFor="let mt of moyenTransportOptions" [value]="mt.value">{{mt.label}}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3 class="form-section-title">Expéditeur et Destinataire</h3>
      <div class="form-row">
        <div class="form-group">
          <label class="form-label">Expéditeur *</label>
          <div style="display: flex; gap: 8px; align-items: flex-end;">
            <input class="form-input" type="text" placeholder="Nom et Prénoms" formControlName="expediteurNom" style="flex: 1;">
            <button type="button" class="btn-icon" (click)="contact('ajout','Expéditeur')" *ngIf="!commandeForm.value['expediteurid']" title="Ajouter">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </button>
            <button type="button" class="btn-icon" (click)="contact('modif','Expéditeur')" *ngIf="commandeForm.value['expediteurid']" title="Modifier">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
            </button>
            <button type="button" class="btn-icon" (click)="contact('rech','Expéditeur')" title="Rechercher">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Destinataire *</label>
          <div style="display: flex; gap: 8px; align-items: flex-end;">
            <input class="form-input" type="text" placeholder="Nom et Prénoms" formControlName="destinataireNom" style="flex: 1;">
            <button type="button" class="btn-icon" (click)="contact('ajout','Destinataire')" *ngIf="!commandeForm.value['destinataireid']" title="Ajouter">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </button>
            <button type="button" class="btn-icon" (click)="contact('modif','Destinataire')" *ngIf="commandeForm.value['destinataireid']" title="Modifier">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
            </button>
            <button type="button" class="btn-icon" (click)="contact('rech','Destinataire')" title="Rechercher">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label class="form-label">Téléphone Expéditeur</label>
          <input class="form-input" type="tel" mask="99-99-99-99-99" placeholder="Numéro de Téléphone" formControlName="expediteurContact">
        </div>
        <div class="form-group">
          <label class="form-label">Téléphone Destinataire</label>
          <input class="form-input" type="tel" mask="99-99-99-99-99" placeholder="Numéro de Téléphone" formControlName="destinataireContact">
        </div>
      </div>
    </div>

    <div class="form-section address-section">
      <h3 class="form-section-title">
        <ng-container *ngIf="modeCommande === 'interurbain' || estTypeInterurbain(); else titreUrbain">
          Zones de départ et de destination
        </ng-container>
        <ng-template #titreUrbain>Adresses de récupération / de livraison</ng-template>
      </h3>

      <!-- MODE INTERURBAIN : deux champs texte simples + sélecteur de trajet/zone -->
      <ng-container *ngIf="modeCommande === 'interurbain' || estTypeInterurbain()">
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Ville / Localité de départ *</label>
            <input type="text" class="form-input" placeholder="Ex : Abidjan, Cocody" formControlName="lieuDepartTexte">
          </div>
          <div class="form-group">
            <label class="form-label">Ville / Localité de destination *</label>
            <input type="text" class="form-input" placeholder="Ex : Bouaké, Centre-ville" formControlName="lieuArriveeTexte">
          </div>
        </div>
        <div class="address-actions address-actions--trajet" style="margin-top: 12px;">
          <button type="button" class="btn btn-secondary" style="flex: 1;" (click)="rechTrajet()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
              <path d="M3 12h18M3 6h18M3 18h18"></path>
            </svg>
            Sélectionner les zones (trajet interurbain)
          </button>
        </div>
        <p *ngIf="trajetLibelle" class="form-hint trajet-hint" style="margin-top: 8px;">
          ✅ Trajet sélectionné : {{ trajetLibelle }}
        </p>
        <p *ngIf="!trajetLibelle" class="form-hint" style="margin-top: 6px; color:#64748b;">
          Cliquez sur « Sélectionner les zones » pour choisir le trajet et calculer automatiquement le prix.
        </p>
      </ng-container>

      <!-- MODE URBAIN : adresses géographiques avec carte -->
      <ng-container *ngIf="modeCommande !== 'interurbain' && !estTypeInterurbain()">
        <div class="form-row">
          <div class="form-group address-field">
            <label class="form-label">Adresse d'expédition *</label>
            <textarea class="form-input" placeholder="Adresse Géographique ..." formControlName="lieuDepartTexte" rows="3"></textarea>
            <div class="coord-preview" *ngIf="commandeForm.value['lieuDepartLatitude'] !== 0 && commandeForm.value['lieuDepartLongitude'] !== 0">
              📍 Lat: {{ commandeForm.value['lieuDepartLatitude'] | number:'1.4-6' }}, Lng: {{ commandeForm.value['lieuDepartLongitude'] | number:'1.4-6' }}
            </div>
            <div class="address-actions">
              <button type="button" class="btn btn-secondary" style="flex: 1;" (click)="rechAdresse('d\'expédition')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                Rechercher une adresse
              </button>
              <button type="button" class="btn btn-secondary" (click)="ouvrirCarte('Expéditeur')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                  <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
                  <line x1="8" y1="2" x2="8" y2="18"></line>
                  <line x1="16" y1="6" x2="16" y2="22"></line>
                </svg>
                Carte
              </button>
            </div>
          </div>
          <div class="form-group address-field">
            <label class="form-label">Adresse de livraison *</label>
            <textarea class="form-input" placeholder="Adresse Géographique ..." formControlName="lieuArriveeTexte" rows="3"></textarea>
            <div class="coord-preview" *ngIf="commandeForm.value['lieuArriveeLatitude'] !== 0 && commandeForm.value['lieuArriveeLongitude'] !== 0">
              📍 Lat: {{ commandeForm.value['lieuArriveeLatitude'] | number:'1.4-6' }}, Lng: {{ commandeForm.value['lieuArriveeLongitude'] | number:'1.4-6' }}
            </div>
            <div class="address-actions">
              <button type="button" class="btn btn-secondary" style="flex: 1;" (click)="rechAdresse('de livraison')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                Rechercher une adresse
              </button>
              <button type="button" class="btn btn-secondary" (click)="ouvrirCarte('Destinataire')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                  <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
                  <line x1="8" y1="2" x2="8" y2="18"></line>
                  <line x1="16" y1="6" x2="16" y2="22"></line>
                </svg>
                Carte
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="form-section">
      <h3 class="form-section-title">Articles à expédier</h3>

      <!-- Bloc spécial TARIFICATION PARTICULIÈRE : choix du mode de saisie -->
      <div class="particuliere-mode-bloc" *ngIf="estClientParticuliere() && !estModeConsultation">
        <div class="particuliere-badge">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          Client sous contrat — tarification particulière
        </div>
        <p class="particuliere-hint">Choisissez comment décrire le colis pour cette commande :</p>
        <div class="particuliere-mode-toggle">
          <button type="button"
            class="particuliere-mode-btn"
            [class.active]="!modeDescriptionLibre"
            (click)="modeDescriptionLibre = false">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"/><path d="M16 3v4M8 3v4"/></svg>
            Articles détaillés
            <span class="particuliere-mode-sub">Saisir les articles avec poids et dimensions</span>
          </button>
          <button type="button"
            class="particuliere-mode-btn"
            [class.active]="modeDescriptionLibre"
            (click)="modeDescriptionLibre = true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            Description libre
            <span class="particuliere-mode-sub">Décrire librement ce qui doit être envoyé</span>
          </button>
        </div>
      </div>

      <!-- Description libre -->
      <div *ngIf="estClientParticuliere() && modeDescriptionLibre && !estModeConsultation" style="margin-top: 16px;">
        <label class="form-label">Description du colis / de l'envoi *</label>
        <textarea class="form-input" rows="4"
          placeholder="Ex : 3 cartons de marchandises, une machine à coudre, des documents administratifs..."
          [(ngModel)]="descriptionLibreTexte"
          [ngModelOptions]="{standalone: true}"></textarea>
        <p class="form-hint" style="margin-top: 6px; color: #64748b;">
          Le montant sera fixé par l'administrateur lors de l'affectation du livreur.
        </p>
      </div>

      <!-- Description libre en mode consultation -->
      <div *ngIf="estModeConsultation && commandeDetail?.descriptionLibreContrat" style="margin-top:8px;">
        <label class="view-label">Description de l'envoi (contrat particulier)</label>
        <p class="view-value" style="white-space: pre-wrap;">{{ commandeDetail.descriptionLibreContrat }}</p>
      </div>

      <!-- Articles standard -->
      <ng-container *ngIf="!estClientParticuliere() || !modeDescriptionLibre">
        <app-data-product
          [displayedColumns]="colonnesAffichees"
          [parentForm]="commandeForm"
          [isViewMode]="estModeConsultation"
          (articleAjoute)="onArticleAjoute()"
          (articleSupprime)="onArticleSupprime($event)"
          (articleModifie)="onArticleModifie($event)">
        </app-data-product>
      </ng-container>

      <div class="info-box" *ngIf="!estClientParticuliere() || !modeDescriptionLibre" style="margin-top: 24px;">
        <h4>Récapitulatif</h4>
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="padding: 8px; border-bottom: 1px solid rgba(0,0,0,0.1);">Montant Total Forfait</td>
            <td style="padding: 8px; text-align: right; border-bottom: 1px solid rgba(0,0,0,0.1); font-weight: 600;">
              {{commandeForm.value['montantTotalForfait'] | number:'1.0-2'}} FCFA
            </td>
          </tr>
          <tr>
            <td style="padding: 8px; border-bottom: 1px solid rgba(0,0,0,0.1);">Montant Total Poids Supplémentaire</td>
            <td style="padding: 8px; text-align: right; border-bottom: 1px solid rgba(0,0,0,0.1); font-weight: 600;">
              {{commandeForm.value['montantTotalSupplementaire'] | number:'1.0-2'}} FCFA
            </td>
          </tr>
          <tr *ngIf="commandeForm.value['montantRemise'] > 0">
            <td style="padding: 8px; border-bottom: 1px solid rgba(0,0,0,0.1);">Remise</td>
            <td style="padding: 8px; text-align: right; border-bottom: 1px solid rgba(0,0,0,0.1); font-weight: 600; color: var(--success);">
              -{{commandeForm.value['montantRemise'] | number:'1.0-2'}} FCFA
            </td>
          </tr>
          <tr style="background: rgba(0,191,165,0.08);">
            <td style="padding: 12px; font-weight: 700; font-size: 16px;">Grand Total</td>
            <td style="padding: 12px; text-align: right; font-weight: 700; font-size: 18px; color: var(--primary-dark);">
              {{commandeForm.value['montantTotalForfait'] + commandeForm.value['montantTotalSupplementaire'] - (commandeForm.value['montantRemise'] || 0) | number:'1.0-2'}} FCFA
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="form-section">
      <h3 class="form-section-title">Autres Informations</h3>
      <div class="form-group">
        <label class="form-label">Remise (FCFA)</label>
        <input class="form-input" type="number" placeholder="Montant de la remise" min="0" step="100" formControlName="montantRemise">
      </div>
      <div class="form-group">
        <label class="form-label">Remarques du Client</label>
        <textarea class="form-input" placeholder="Saisir les remarques ici ..." formControlName="observations" rows="4"></textarea>
      </div>
    </div>

    <div class="form-actions">
      <a [routerLink]="'/commande/lister'" class="btn btn-secondary">Annuler</a>
      <button type="submit" class="btn btn-primary" [disabled]="estEnChargement">
        <ng-container *ngIf="!estEnChargement">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          Enregistrer la commande
        </ng-container>
        <ng-container *ngIf="estEnChargement">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16" class="spin">
            <line x1="12" y1="2" x2="12" y2="6"></line>
            <line x1="12" y1="18" x2="12" y2="22"></line>
            <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
            <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
            <line x1="2" y1="12" x2="6" y2="12"></line>
            <line x1="18" y1="12" x2="22" y2="12"></line>
            <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
            <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
          </svg>
          Enregistrement...
        </ng-container>
      </button>
    </div>

    <app-spinner *ngIf="estEnChargement"></app-spinner>
  </form>

</section>
<!-- ══ ASSIGN SHEET — hors de content-section pour échapper au stacking context
     de l'animation u-fadeUp (z-index:auto = 0, sous le header z-index:10) ══ -->
<div class="assign-sheet-backdrop" *ngIf="panelAffectationOuvert" (click)="fermerPanelAffectation()"></div>
<aside class="assign-sheet" *ngIf="panelAffectationOuvert" aria-modal="true" role="dialog" aria-labelledby="assign-sheet-title">
  <div class="assign-sheet-header">
    <div>
      <h3 id="assign-sheet-title">Affectation livreur</h3>
      <p class="assign-sheet-lead">
        Commande
        <strong *ngIf="commandeDetail?.numeroCommande || commandeDetail?.numeroSuivi">{{ commandeDetail?.numeroCommande || commandeDetail?.numeroSuivi }}</strong>
        <span *ngIf="!commandeDetail?.numeroCommande && !commandeDetail?.numeroSuivi && commandeId">#{{ commandeId }}</span>
      </p>
      <p class="assign-sheet-sub">Choisissez un livreur disponible à proximité.</p>
    </div>
    <button
      type="button"
      class="assign-sheet-close"
      (click)="fermerPanelAffectation()"
      [disabled]="assignationEnCours"
      aria-label="Fermer">✕</button>
  </div>

  <!-- Bloc montant — visible uniquement pour les commandes à tarification particulière -->
  <div class="assign-sheet-contrat-montant" *ngIf="commandeDetail?.flgTarificationParticuliere">
    <div class="assign-sheet-contrat-badge">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
      Commande sous contrat — tarification particulière
    </div>
    <div class="assign-sheet-contrat-desc" *ngIf="commandeDetail?.descriptionLibreContrat">
      <span class="assign-sheet-contrat-label">Description client :</span>
      {{ commandeDetail.descriptionLibreContrat }}
    </div>
    <label class="assign-sheet-contrat-label" for="montantContratDetail">Montant à facturer (FCFA) <span class="req">*</span></label>
    <input
      id="montantContratDetail"
      type="number"
      min="0"
      class="form-input"
      placeholder="Ex : 15 000"
      [(ngModel)]="montantContrat">
  </div>

  <div class="assign-sheet-search">
    <input
      type="search"
      class="form-input"
      placeholder="Nom, téléphone ou adresse"
      [(ngModel)]="rechercheLivreur"
      (ngModelChange)="filtrerLivreursPanel()"
      autocomplete="off">
  </div>

  <div class="assign-sheet-body">
    <div class="assign-sheet-loading" *ngIf="chargementLivreurs">
      <div class="spinner"></div>
      <p>Chargement des livreurs…</p>
    </div>

    <div class="assign-sheet-empty" *ngIf="!chargementLivreurs && livreursPanelFiltres.length === 0">
      Aucun livreur ne correspond à cette recherche ou à cette commande.
    </div>

    <div class="assign-sheet-grid" *ngIf="!chargementLivreurs && livreursPanelFiltres.length > 0">
      <article class="assign-sheet-card" *ngFor="let livreur of livreursPanelFiltres">
        <div class="assign-sheet-card-head">
          <h4>{{ livreur.nom }} {{ livreur.prenom }}</h4>
          <span class="tag-dispo">Disponible</span>
        </div>
        <p>📱 {{ livreur.contact || '—' }}</p>
        <p>📍 {{ livreur.adresse || 'Adresse non renseignée' }}</p>
        <p>📦 {{ livreur.nombreCommandesEnCours || 0 }} course(s) en cours</p>
        <p *ngIf="livreur.vehiculeActuel">
          <span *ngIf="libelleTypeVehicule(livreur) as tv">{{ tv }} — </span>{{ livreur.vehiculeActuel.marque }} {{ livreur.vehiculeActuel.modele }}
          <span class="tag-immat">{{ livreur.vehiculeActuel.immatriculation }}</span>
        </p>
        <p *ngIf="!livreur.vehiculeActuel" style="color:#9ca3af; font-style:italic;">Véhicule non renseigné</p>
        <button
          type="button"
          class="btn btn-primary assign-sheet-cta"
          [disabled]="assignationEnCours"
          (click)="assignerLivreurDepuisPanel(livreur)">
          Assigner ce livreur
        </button>
      </article>
    </div>
  </div>
</aside>
<!-- ══ MAP FULLSCREEN SHEET — hors de content-section pour éviter le
     stacking context CSS qui casse position:fixed ══ -->
<div class="vd-sheet-backdrop" *ngIf="carteSheetVisible" (click)="fermerSheetCarte()"></div>
<div class="vd-sheet" [class.vd-sheet-open]="carteSheetVisible">
  <div class="vd-sheet-drag-bar" (click)="fermerSheetCarte()"><div class="vd-sheet-drag-handle"></div></div>
  <div class="vd-sheet-header">
    <div class="vd-sheet-header-left">
      <div class="vd-sheet-title">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><polygon points="3 6 9 3 15 6 21 3 21 21 15 18 9 21 3 18 3 6"/></svg>
        Suivi en temps réel
      </div>
      <div class="vd-sheet-sub" *ngIf="commandeDetail">
        {{ commandeDetail.numeroCommande || commandeDetail.numeroSuivi }}
        <span class="vd-statut-chip vd-chip-{{ commandeDetail.statut }}" style="font-size:10px; padding:2px 8px; margin-left:6px">{{ obtenirTexteStatut(commandeDetail.statut) }}</span>
      </div>
    </div>
    <div class="vd-sheet-header-right">
      <span class="vd-live-badge" *ngIf="['AFFECTE','EN_PREPARATION','EN_LIVRAISON'].includes(commandeDetail?.statut || '')">
        <span class="live-dot"></span>LIVE
      </span>
      <button type="button" class="vd-sheet-close" (click)="fermerSheetCarte()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="20" height="20"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
  </div>
  <div class="vd-sheet-map" *ngIf="carteSheetVisible && commandeId">
    <app-tracking-map
      [commandeId]="commandeId"
      [departLat]="commandeForm.get('lieuDepartLatitude')?.value"
      [departLng]="commandeForm.get('lieuDepartLongitude')?.value"
      [arriveeLat]="commandeForm.get('lieuArriveeLatitude')?.value"
      [arriveeLng]="commandeForm.get('lieuArriveeLongitude')?.value"
      [departTexte]="commandeForm.get('lieuDepartTexte')?.value"
      [arriveeTexte]="commandeForm.get('lieuArriveeTexte')?.value"
      [statut]="commandeDetail?.statut">
    </app-tracking-map>
  </div>
  <div class="vd-sheet-footer">
    <div class="vd-sheet-legend">
      <span class="vd-sheet-legend-item"><span class="vd-legend-dot" style="background:#22c55e">D</span> Départ</span>
      <span class="vd-sheet-legend-item"><span class="vd-legend-dot" style="background:#ef4444">A</span> Arrivée</span>
      <span class="vd-sheet-legend-item"><span class="vd-legend-dot" style="background:#3b82f6">🚴</span> Livreur</span>
    </div>
    <button type="button" class="btn btn-secondary" style="font-size:13px; padding:6px 14px" (click)="fermerSheetCarte()">Fermer</button>
  </div>
</div>
